import { Component, Input, OnInit } from '@angular/core';
import { SocioEmotionalSkill, SkillLevel } from '../../socio-emotional-skills-test/socio-emotional-skills-test.models';
import { SocioEmotionalSkillTestResult } from '../socio-emotional-skills-test-results.models';

@Component({
  selector: 'app-socio-emotional-skills-test-results-general',
  templateUrl: './socio-emotional-skills-test-results-general.component.html',
  styleUrls: ['./socio-emotional-skills-test-results-general.component.scss']
})
export class SocioEmotionalSkillsTestResultsGeneralComponent implements OnInit {
  @Input() generalSocioEmotionalSkill: SocioEmotionalSkill;
  @Input() lastThreeResults: SocioEmotionalSkillTestResult[];

  chartOptions: any;
  levelDescription = '';
  lastGeneralScore = 0;

  ngOnInit(): void {
    this.buildChart();
  }

  private buildChart(): void {
    const sortedResults = this.getSortedResults();
    const generalScores = this.getGeneralScores(sortedResults);
    const labels = this.getLabels(sortedResults);
    const barColors = this.getBarColors(generalScores);

    this.lastGeneralScore = generalScores[generalScores.length - 1];
    this.levelDescription = this.getLevelDescription(this.lastGeneralScore);

    this.chartOptions = this.createChartOptions(generalScores, labels, barColors);
  }

  private getSortedResults(): SocioEmotionalSkillTestResult[] {
    return [...this.lastThreeResults].sort(
      (a, b) => new Date(a.submittedAt).getTime() - new Date(b.submittedAt).getTime()
    );
  }

  private getGeneralScores(results: SocioEmotionalSkillTestResult[]): number[] {
    return results.map(result => result.generalScore);
  }

  private getLabels(results: SocioEmotionalSkillTestResult[]): string[] {
    return results.map(r =>{
      if(r.semesterName){
        return r.semesterName;
      }
      return  new Date(r.submittedAt).toLocaleDateString('es-CO', { month: 'short', day: 'numeric' })
    }
    );
  }

  private getBarColors(scores: number[]): string[] {
    return scores.map(score => this.getLevelColor(score));
  }

  private getLevelColor(score: number): string {
    return this.generalSocioEmotionalSkill.levels.find(
      level => score >= level.minScore && score <= level.maxScore
    )?.color || '#ccc';
  }

  private getLevelDescription(score: number): string {
    return this.generalSocioEmotionalSkill.levels.find(
      level => score >= level.minScore && score <= level.maxScore
    )?.description || '';
  }

  private createChartOptions(data: number[], labels: string[], colors: string[]): any {
    return {
      series: [{
        name: 'Inteligencia Emocional',
        data
      }],
      chart: {
        type: 'bar',
        height: 250,
        width: '100%',
      },
      xaxis: {
        categories: labels
      },
      yaxis: {
        min: 0,
        max: 100
      },
      plotOptions: {
        bar: {
          distributed: true,
          columnWidth: '40%'
        }
      },
      colors,
      dataLabels: {
        enabled: false
      }
    };
  }
}
